import mongoose, { Schema } from 'mongoose';
import {
  always,
  applySpec,
  converge,
  compose,
  nthArg,
  propOr,
} from 'ramda';
import { string } from '@555platform/utility-belt.js';
import { renameObjectKeys } from '../util';
import { query as queryModel } from './util';

const apnKeyCertSchema = new Schema({
  className: { type: String },
  readAccess: [String],
  writeAccess: [String],
  ownerID: { type: String },
  createAt: { type: Date },
  updatedAt: { type: Date },
  fields: {
    app_key: { type: String },
    // app_domain_client_id: {type: String},
    // app_domain: {type:String},
    apns_cert: { type: String },
    apns_key: { type: String },
    apns_production: { type: String },
  },
});

const applyFieldScope = string.createTemplate('fields.${}');

export const apnKeyCertModel = () => mongoose.model(
  'apnKeyCertinfo',
  apnKeyCertSchema,
  'ApnKeyCertInfo',
);

export const query = queryModel(apnKeyCertModel);

// apnKeyCertSchema.findByAppKey = (app_domain_client_id) => {
//    const apnKeyCert = apnKeyCertModel();
//    return apnKeyCert.findOne({'fields.app_key' : app_domain_client_id});
// };

apnKeyCertSchema.statics.findByAppKey = compose(
  query('findOne'),
  applySpec({
    'fields.app_key': nthArg(0),
    ownerID: nthArg(1),
  }),
);

const now = () => new Date();

apnKeyCertSchema.statics.upsert = converge(
  query('findOneAndUpdate'),
  [
    applySpec({ 'fields.app_key': propOr('__', 'app_key') }),
    applySpec({
      updatedAt: now,
      $setOnInsert: { ownerID: nthArg(1), createdAt: now },
      $set: renameObjectKeys(applyFieldScope),
    }),
    always({
      upsert: true,
      setDefaultsOnInsert: true,
      new: true,
    }),
  ],
);


export default apnKeyCertModel;
